import { Box, Button, IconButton } from "@mui/material";
import { FC } from "react";
import GarmentTypeSection from "../../../../common/pos/garment-type-section/garment-type-section";
import GarmentColorSection from "../../../../common/pos/garment-color-section/garment-color-section";
import GarmentMaterialSection from "../../../../common/pos/garment-material-section/garment-material-section";
import GarmentTextureSection from "../../../../common/pos/garment-texture-section/garment-texture-section";
import GarmentStyleSection from "../../../../common/pos/garment-style-section/garment-style-section";
import MoreIcon from "../../../../../assets/images/more";
import { Colors } from "../../../../../configs";
import { useAppDispatch, useAppSelector } from "../../../../../hooks";
import { addCartItem } from "../../../../../redux/actions/cartAction";
import { Link, useParams } from "react-router-dom";
import { CustomButton, PosButton } from "../../../../atoms";
import BottomActionButtons from "../BottomActionButtons";
import { CheckroomOutlined, Redo } from "@mui/icons-material";
import ServiceActionButtons from "../../../../common/pos/service-action-buttons/service-action-buttons";
import RedoModal from "../../../redo-modal/RedoModal";
import { primaryAlpha } from "../../../../../configs/colors";

const Leather: FC = () => {
  const params = useParams();
  const { selectedCartItem } = useAppSelector((state) => state.cart);
  const dispatch = useAppDispatch();
  const disableAddButton = !(
    selectedCartItem?.garmentType !== undefined &&
    selectedCartItem.materialType !== undefined &&
    selectedCartItem.garmentStyle !== undefined
  );

  const handleOnAddItem = () => {
    dispatch(addCartItem());
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "0.57rem",
          justifyContent: "space-between",
        }}
      >
        <GarmentTypeSection />
        <GarmentColorSection />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "0.57rem",
          justifyContent: "space-between",
        }}
      >
        <GarmentMaterialSection />
        <GarmentTextureSection />
      </Box>
      <GarmentStyleSection />
      <Box
        sx={{
          marginTop: "auto",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0rem 0.928571429rem",
          gap: "1.5rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "2.5rem",
          }}
        >
          <Link to={`/pos/customer/${params.id}/history/`}>
            <PosButton
              variant="outlined"
              sx={{
                width: "28.21428571428571rem",
                borderRadius: "1.43rem",
                boxShadow: `0 6px 16px ${primaryAlpha(0.18)}`,
                transition: "transform 0.15s ease",
                "&:active": {
                  transform: "scale(0.99)",
                },
              }}
            >
              Pickups
            </PosButton>
          </Link>
        </Box>
        <ServiceActionButtons />
        <BottomActionButtons
          onAddClick={handleOnAddItem}
          disable={disableAddButton}
        />
        <RedoModal />
      </Box>
    </>
  );
};

export default Leather;
